import React, { useImperativeHandle } from "react"; 
import { useState } from "react";
 
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const TextEditor = React.forwardRef(({ onChangeText }, ref) => {
  const [editorState, setEditorState] = useState("");

  useImperativeHandle(ref, () => ({
    setEditorValue(value) {
      setEditorState(value);
    },
  }));

  const onEditorStateChange = (text) => {
    setEditorState(text);
    onChangeText(text);
 
  };
  var toolbarOptions = [
    ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
    ['blockquote', 'code-block'],
  
    [{ 'header': 1 }, { 'header': 2 }],               // custom button values
    [{ 'list': 'ordered'}, { 'list': 'bullet' }],
    [{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
    [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
    [{ 'direction': 'rtl' }],                         // text direction
  
    [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
    [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
  
    [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
    [{ 'font': [] }],
    [{ 'align': [] }],
  
    ['clean']                                         // remove formatting button
  ];
  const modules = {
    toolbar: toolbarOptions
}
const formats = [
  'font','size',
  'bold','italic','underline','strike',
  'color','background',
  'script',
  'header','blockquote','code-block',
  'indent','list',
  'direction','align',
  'link','image','video','formula',
]
  return (
    <div className="min-h-[250px] w-full">

         <ReactQuill
         theme="snow"
          onChange={onEditorStateChange}
          value={editorState} 
          modules={modules}
          formats={formats}
          
          className="min-h-[250px]"
        />
    </div>
  );
});
export default TextEditor;